import { render } from "./TiaoJiaoPage.vue?vue&type=template&id=ff8dcd4c&scoped=true"
import script from "./TiaoJiaoPage.vue?vue&type=script&lang=js"
export * from "./TiaoJiaoPage.vue?vue&type=script&lang=js"

import "./TiaoJiaoPage.vue?vue&type=style&index=0&id=ff8dcd4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8dcd4c"]])

export default __exports__